import { ModelsHelper } from "oc-app/ModelsHelper";
import * as Commons from "oc-commons/Commons";
import { MModelMaterialRelation } from "../metamodell";
import { checkMMR } from "./RichMetadata";

export class MyModelsHelper extends ModelsHelper {
  mmrToRenderPromise = Commons.cacheWeak((modelMaterialRelation: MModelMaterialRelation) =>
    this.loadModelPromise(modelMaterialRelation.Model, modelMaterialRelation.MaterialMap)
  );

  getRenderPromise(modelMaterialRelation: MModelMaterialRelation) {
    checkMMR(modelMaterialRelation);
    if (modelMaterialRelation == null) {
      return Promise.resolve(null);
    }
    const promise = this.mmrToRenderPromise(modelMaterialRelation);
    return promise.then((o) => o.clone());
  }

  getBoundingBox(modelMaterialRelation: MModelMaterialRelation) {
    checkMMR(modelMaterialRelation);
    if (modelMaterialRelation == null) {
      debugger;
    }
    return super.getBoundingBox(modelMaterialRelation.Model);
  }

  setModelDataFromObject(model_, object3d) {
    const model = model_?.Model ?? model_;
    return super.setModelDataFromObject(model, object3d);
  }

  loadModelPromise(model_, materialMap = undefined) {
    const model = model_?.Model ?? model_;
    return super.loadModelPromise(model, materialMap);
  }

  getConnectorsFromModelRelativeToObject(model_, object3d) {
    const model = model_?.Model ?? model_;
    return super.getConnectorsFromModelRelativeToObject(model, object3d);
  }

  applyToObject3d(model_, object3d) {
    const model = model_?.Model ?? model_;
    return super.applyToObject3d(model, object3d);
  }
}
